import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

let inflight = 0;
const emitBusy = () => window.dispatchEvent(new CustomEvent("kirana:busy", { detail: inflight > 0 }));

// Ring buffer of the last 20 API calls for the Sync Debug Panel.
const LOG_MAX = 20;
export const apiLog = [];
const pushLog = (entry) => {
  apiLog.unshift(entry);
  if (apiLog.length > LOG_MAX) apiLog.length = LOG_MAX;
  window.dispatchEvent(new CustomEvent("kirana:api-log"));
};

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  if ((cfg.method || "get").toLowerCase() === "get") {
    cfg.headers["Cache-Control"] = "no-cache";
    cfg.headers["Pragma"] = "no-cache";
    cfg.params = { ...(cfg.params || {}), _t: Date.now() };
  }
  cfg.metadata = { startedAt: Date.now() };
  inflight++; emitBusy();
  return cfg;
});
api.interceptors.response.use(
  (res) => {
    inflight = Math.max(0, inflight - 1); emitBusy();
    pushLog({
      ts: new Date().toISOString(),
      method: (res.config.method || "get").toUpperCase(),
      url: (res.config.url || "").split("?")[0],
      status: res.status,
      ms: Date.now() - (res.config.metadata?.startedAt || Date.now()),
    });
    return res;
  },
  (err) => {
    inflight = Math.max(0, inflight - 1); emitBusy();
    pushLog({
      ts: new Date().toISOString(),
      method: (err.config?.method || "get").toUpperCase(),
      url: (err.config?.url || "").split("?")[0],
      status: err.response?.status || 0,
      ms: Date.now() - (err.config?.metadata?.startedAt || Date.now()),
      error: err.message || "network error",
    });
    return Promise.reject(err);
  },
);

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") window.dispatchEvent(new CustomEvent("kirana:revalidate"));
  });
  window.addEventListener("focus", () => window.dispatchEvent(new CustomEvent("kirana:revalidate")));
}

export default api;
